import * as moment from 'moment';
import { from } from 'rxjs';
import { flatMap } from 'rxjs/operators';
export const baseURL = process.env.REACT_APP_API_URL;

export interface InsertResult {
  id: number;
  status: 'success' | 'error';
}

// tslint:disable-next-line:no-any
function toQueryString(params: { [key: string]: any }) {
  return Object
    .keys(params)
    .filter(k => params[k])
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&')
    ;
}

const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/;
// tslint:disable-next-line
const reviver = (_key: any, value: any) => {
  if (typeof value === 'string' && iso8601Regex.test(value)) {
    return moment(value);
  } else {
    return value;
  }
};

export const fetchJSON$ = <T>(url: string, payload: T, method: string = 'POST') => {
  let rURL = baseURL + url;
  if (method === 'GET') {
    // tslint:disable-next-line:no-any
    rURL += `?${toQueryString(payload as any)}`;
  }

  const fetch$ = from(
    fetch(rURL, {
      body: (method === 'POST' || method === 'PUT') ? JSON.stringify(payload) : undefined,
      method,
    })
  );
  return fetch$.pipe(
    flatMap(async resp => {
      const text = await resp.text();
      if (resp.status >= 200 && resp.status < 300) {
        return text ? JSON.parse(text, reviver) : undefined;
      } else {
        return {
          error: text,
          status: 'error',
        };
      }
    })
  );
};



// WEBPACK FOOTER //
// ./src/api.ts